import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';
import FormikInputGroup from '@components/smartAdminUI/input/FormikInputGroup';
import Button from '@components/smartAdminUI/Button';
import MapModal from '@components/form/formComponents/inputGroups/locationPlotter/MapModal';

// Will populate the latitude and longitude

const LocationPlotter = ({
  fields,
  validateFigField,
}) => {
  const latField = useMemo(() => fields.find(field => field.FieldName === 'Latitude'), [fields]);
  const longField = useMemo(() => fields.find(field => field.FieldName === 'Longitude'), [fields]);

  const { setFieldValue } = useFormikContext();

  const onLocationCleared = () => {
    if (fields) {
      fields.map(field => {
        setFieldValue(field.FieldName, '');
        return null;
      });
    }
  };

  return (
    <>
      <div className="form-row mb-3">
        <div className="col-md-5">
          <FormikInputGroup
            {...latField}
            key={latField.RowID}
            validateFigField={validateFigField}
          />
        </div>
        <div className="col-md-5">
          <FormikInputGroup
            {...longField}
            key={longField.RowID}
            validateFigField={validateFigField}
          />
        </div>
        <div className="col-auto">
          <div className="form-group mt-4 mb-4">
            <Button
              name="btnLookupLocationClear"
              onClick={onLocationCleared}
              variant="primary"
              tooltipText="Clear Location"
            >
              <i className="far fa-times" aria-hidden="true" />
            </Button>
            <span data-toggle="modal" data-target="#locationPlotterModal">
              <Button
                name="btnLookupLocation"
                variant="primary"
                tooltipText="Location Lookup"
              >
                <i className="fas fa-globe-americas" aria-hidden="true" />
              </Button>
            </span>
          </div>
        </div>
      </div>
      <MapModal />
    </>
  );
};

LocationPlotter.propTypes = {
  fields: PropTypes.arrayOf(PropTypes.shape()),
  validateFigField: PropTypes.func.isRequired,
};

export default LocationPlotter;
